import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import crmlogo from "../assets/images/crm-logo-ngang.png";
import avatar_men from "../assets/images/avatar_men.png";
import avatar_girl from "../assets/images/avatar_girl.png";
import useOnclickOutside from "use-onclickoutside";
import SiderBar from './Sidebar';
import { jwtDecode } from "jwt-decode";
import { setReloadCustomer, saveCustomer, setResetPost, saveCountCV, saveBangHang } from '../redux/Actions';
import wavFile from "../assets/notification.wav"
import _ from 'lodash';
import { URL_LIST_ALL } from '../configs/api';
import Axios from "axios";
import { actions } from '../redux/authRedux';
import parse from 'html-react-parser'

export default function AkkhorLayout({ children, idrole, roleignone, class_name }) {
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const MyRole = JSON.parse(user && user.data.roles ? user.data.roles : '{}')
    const [sideBarShow, setSideBarShow] = useState(false)
    const [showNotification, setShowNotification] = useState(false)
    const [showProfile, setShowProfile] = useState(false)
    const ref = useRef();
    const [socket, setSocket] = useState(null);
    const [soundPlay, setSoundPlay] = useState(false);
    const [dataNotifi, setDataNotifi] = useState(null);
    const [refreshNoti, setRefreshNoti] = useState(false);
    const [listNotification, setListNotification] = useState(null);
    const [countNoti, setCountNoti] = useState(0);
    const audio = new Audio(wavFile);


    const checkRole = () => {
        const arr = idrole.split('.')
        let isrole = false;
        if (idrole === 'my-profile' || idrole === 'update-profile' || idrole === 'change-password') isrole = true
        else if (roleignone) isrole = true
        else if (arr.length === 2 && MyRole.hasOwnProperty(arr[0]) && MyRole[arr[0]].children.hasOwnProperty(arr[1]) && MyRole[arr[0]].children[arr[1]].checked === true) isrole = true
        else if (idrole && MyRole.hasOwnProperty(idrole) && MyRole[idrole].checked === true) isrole = true
        return isrole
    }

    useOnclickOutside(ref, () => {
        setShowNotification(false)
        setShowProfile(false)
        setSideBarShow(false)
    });

    useEffect(() => {
        const connectWebSocket = () => {
            // setFlag(true)
            const socketInstance = new WebSocket('wss://crmsk.bhsgroup.vn');
            socketInstance.onopen = () => { };
            socketInstance.onmessage = (evt) => {
                if (evt.data) {
                    let data = evt.data
                    try {
                        data = jwtDecode(data)
                        if (data) {
                            let channel = 'bcrm'
                            if (window.location.hostname == 'devbcrm.bhsgroup.vn') {
                                channel = "bcrmdev"
                            }
                            if (data.channel && data.channel == channel) {
                                let sound = 0;
                                if (data.event == 'customer') {
                                    sound = 0
                                    dispatch(saveCustomer(data.data));
                                }
                                if (data.event == 'banghang') {
                                    sound = 0
                                    dispatch(saveBangHang(data.data));
                                }
                                if (data.event == 'reaload_customer') {
                                    sound = 0
                                    const datasend = data.data
                                    const list_uId = datasend.user_id
                                    const userId = user?.data?.id;
                                    if (list_uId.includes(userId)) {
                                        // console.log(datasend);
                                        dispatch(setReloadCustomer(datasend.time));
                                    }
                                }
                                if (data.event == 'notifications' && data.data.to_user_id == user.data.id) {
                                    setRefreshNoti(data.data)
                                    setSoundPlay(true)
                                    if (data.data.node_type != dataNotifi) setDataNotifi(data.data.node_type)
                                }
                            }
                        }
                    } catch (error) {
                    }
                }
            };
            socketInstance.onclose = (event) => {
                setTimeout(() => {
                    connectWebSocket();
                }, 1000);
            };
            setSocket(socketInstance);
        };
        if (!socket) {
            connectWebSocket();
        }
        return () => {
            if (socket) {
                socket.close();
            }
        };
    }, [socket]);

    const markSeen = (id, href = null) => {
        Axios.put(URL_LIST_ALL + "notifications/" + id, { seen: 1 }, user.config).then(async (res) => {
            if (href) {
                window.location.href = href
            } else {
                setRefreshNoti(!refreshNoti)
            }
        })
    }
    const markSeenAll = (id, href = null) => {
        Axios.post(URL_LIST_ALL + "seenall", {}, user.config).then(async (res) => {
            if (href) {
                window.location.href = href
            } else {
                document.title = 'BHS - Nội bộ'
                setRefreshNoti(!refreshNoti)
            }
        })
    }

    useEffect(() => {
        if (user.data) {
            Axios.get(URL_LIST_ALL + "notifications?limit=30&to_user_id=" + user.data.id, user.config).then(async (res) => {
                if (res.data.status === 'success') {
                    let datars = res.data.data
                    setListNotification(datars)
                    let count_no_seen = 0
                    datars.forEach((item) => {
                        if (item.seen == 0 || !item.seen) {
                            count_no_seen += 1;
                        }
                    });
                    // console.log(count_no_seen);
                    if (count_no_seen > 99) {
                        count_no_seen = 99
                    }
                    if (count_no_seen > 0) document.title = 'BCRM (' + count_no_seen + ' thông báo)';
                    setCountNoti(count_no_seen)
                    if (res.data.countcv) {
                        dispatch(saveCountCV(res.data.countcv))
                    }

                    if (res.data.roles && user.data.roles) {
                        const localRole = structuredClone(JSON.parse(user.data.roles))
                        const svRole = JSON.parse(res.data.roles);
                        const isEqual = _.isEqual(localRole, svRole);
                        // console.log(isEqual);
                        if (!isEqual) {
                            let newUser = Object.assign({}, user);
                            newUser.data.roles = res.data.roles
                            dispatch(actions.login(newUser));
                        }
                    }
                } else {
                    alert(res.data.message)
                }
            }).catch((err) => { console.log(err); });
        }
    }, [user.data, refreshNoti])

    useEffect(() => {
        if (soundPlay) {
            try {
                audio.play()
            } catch (error) {

            }
            setSoundPlay(false)
        }
    }, [soundPlay]);

    useEffect(() => {
        if (dataNotifi) {
            setShowNotification(dataNotifi)
        }
    }, [dataNotifi]);

    return (<>

        <div id="wrapper" className={"main-wrapper " + (sideBarShow ? 'slide-nav' : '')} ref={ref}>
            <div className="header">
                <div className="header-left active">
                    <a href="/" className="logo logo-normal">
                        <img src={crmlogo} alt="Logo" />
                        <img src={crmlogo} className="white-logo" alt="Logo" />
                    </a>
                    <a href="/" className="logo-small">
                        <img src={crmlogo} alt="Logo" />
                    </a>
                </div>

                <button type='button' className="mobile_btn" onClick={() => setSideBarShow(!sideBarShow)}>
                    <span className="bar-icon">
                        <span></span>
                        <span></span>
                        <span></span>
                    </span>
                </button>

                <div className="header-user">
                    <ul className="nav user-menu justify-content-end">
                        <li className="nav-item dropdown nav-item-box li-notifi">
                            <button type='button' className="nav-link" data-bs-toggle="dropdown" onClick={() => setShowNotification(!showNotification)}>
                                <i className="far fa-bell"></i>
                                <span className="badge rounded-pill">{countNoti}</span>
                            </button>
                            <div className={"dropdown-menu dropdown-menu-end notification-dropdown " + (showNotification ? 'show' : '')}>
                                <div className="topnav-dropdown-header">
                                    <h4 className="notification-title">Thông báo</h4>
                                </div>
                                <div className="noti-content">
                                    <div className="w-100 d-flex justify-content-end border-bottom pl-2 pr-2">
                                        <button className="btn read-all" type="button" onClick={() => markSeenAll()}>Đánh dấu đọc tất cả</button>
                                    </div>
                                    <ul className="notification-list">
                                        {listNotification ? listNotification.map((item, i) => {
                                            return (<div className={"notification-item d-flex justify-content-between p-2 " + (item.seen === 1 ? "seen" : '')} key={i}>
                                                {item.avatar ?
                                                    <img src={item.avatar} alt="" className="avatar" />
                                                    :
                                                    ''
                                                }
                                                <div className="content pl-2" onClick={() => { markSeen(item.id, item.node_url) }}>
                                                    <div className="w-100">
                                                        {parse(item.node_type)}
                                                    </div>
                                                    <div className="timmer">
                                                        <small>Lúc {item.time}</small>
                                                    </div>
                                                </div>
                                                {item.seen !== 1 &&
                                                    <div className="btn-seen">
                                                        <button className="btn p-0" type="button" title="Đánh dấu là đã xem" onClick={() => { markSeen(item.id) }}>
                                                            <i className="far fa-dot-circle"></i>
                                                        </button>
                                                    </div>
                                                }
                                            </div>)
                                        })
                                            :
                                            <p className="p-2">Không có thông báo nào</p>
                                        }
                                    </ul>
                                </div>
                            </div>
                        </li>

                        <li className="nav-item dropdown has-arrow main-drop">
                            <button type='button' className="nav-link userset" data-bs-toggle="dropdown" onClick={() => setShowProfile(!showProfile)}>
                                <span className="user-info">
                                    <span className="user-letter">
                                        <img src={user && user.data.avatar ? user.data.avatar : (user.data.sex == 'Nam' ? avatar_men : avatar_girl)} alt="Profile" />
                                    </span>
                                    <span className="badge badge-success rounded-pill"></span>
                                </span>
                            </button>
                            <div className={"dropdown-menu menu-drop-user " + (showProfile ? "show" : '')}>
                                <div className="profilename">
                                    <a className="dropdown-item" href="/profile">
                                        <i className="ti ti-user-pin"></i> Cá nhân
                                    </a>
                                    <a className="dropdown-item" href="/auth/logout">
                                        <i className="ti ti-lock"></i> Đăng xuất
                                    </a>
                                </div>
                            </div>
                        </li>


                    </ul>
                </div>
                <div className="dropdown mobile-user-menu">
                    <button type='button' className="nav-link dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"><i className="fa fa-ellipsis-v"></i></button>
                    <div className="dropdown-menu">
                        <a className="dropdown-item" href="/">
                            <i className="ti ti-layout-2"></i> Trang chủ
                        </a>
                        <a className="dropdown-item" href="/profile">
                            <i className="ti ti-user-pin"></i> Cá nhân
                        </a>
                        <a className="dropdown-item" href="/auth/logout">
                            <i className="ti ti-lock"></i> Đăng xuất
                        </a>
                    </div>
                </div>
            </div>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='sidebar'>
                        <div className='sidebar-menu'>
                            <ul>
                                <li className="clinicdropdown">
                                    <a href="/profile">
                                        <img src={user && user.data.avatar ? user.data.avatar : (user.data.sex == 'Nam' ? avatar_men : avatar_girl)} alt="Profile" />
                                        <div className="user-names">
                                            <h5>{user.data.fullname}</h5>
                                            <h6>{user.data.rolename}</h6>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                            <SiderBar />
                        </div>
                    </div>
                    <div className={"page-wrapper " + (class_name ? class_name : '')}>
                        <div className='content'>
                            {checkRole() || idrole == "dashboard" ? <>{children}</> : <>
                                <div className="card mt-4 d-flex align-items-center justify-content-center">
                                    <h3 className="text-danger text-center">Bạn không có quyền truy cập vào chức năng này!!!</h3>
                                </div>
                            </>}
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </>
    );
}
